module.exports = __webpack_public_path__ + "static/media/cart-orange.a1c8c7d2.svg";